import { makeAutoObservable, runInAction } from 'mobx';

import { PermissionsApi } from './permissions.api';
import { UserPermissionDto } from './permissions.dto';

class PermissionsStore {
  permissionsApi: PermissionsApi;

  isLoading = false;

  permissions: UserPermissionDto[];

  constructor() {
    this.permissionsApi = new PermissionsApi();
    this.permissions = [];

    makeAutoObservable(this, {}, { autoBind: true });
  }

  public async getAllPermissions() {
    this.isLoading = true;

    try {
      const response = await this.permissionsApi.getAllPermissions();

      runInAction(() => {
        this.permissions = response;
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }
}

export default PermissionsStore;
